import { render, staticRenderFns } from "./ObkDescriptionIdNoteStep.vue?vue&type=template&id=6bf98aec&scoped=true"
import script from "./ObkDescriptionIdNoteStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionIdNoteStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf98aec",
  null
  
)

export default component.exports